module.exports = __webpack_public_path__ + "img/option-card-right-active-modal-icon.3e4e0cca.svg";